import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation  } from 'react-router-dom'; 
import { useForm } from 'react-hook-form'; // <-- Import `useForm` here
import { Audio } from 'react-loader-spinner';
import { MdOutlineCancel } from "react-icons/md"; // <-- NEW: Import for the close icon
import { BsBank } from "react-icons/bs";
import { HiOutlineReceiptTax } from "react-icons/hi";
import { FaRegBuilding } from "react-icons/fa";
import { FaUserCircle } from "react-icons/fa";
import { MdAccountCircle } from "react-icons/md";
import {Layout, CategoryProfile, CategoryConfig} from '../../../../components';
import {handleApi,findRecordSafe} from '../../../../utils/utils';
import AppContext from '../../../../contexts/AppContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import '../styles/style.css';

const NewCategory = () => {
  const location = useLocation();
  const categorys = location.state?.categorys || [];
  const { reset, control, register, handleSubmit, formState: { errors } } = useForm();
  const [category, setCategory] = useState({
      name: '',
      parent_category: '',
       });

  const [categories, setCategories] = useState([]);
  const [uoms, setUoms] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [displayImg, setDisplayImg] = useState(''); 
  const [imgType, setImgType] = useState('');
  const { userData, companyProfile, bank, currentColor, actionCount, setActionCount } = useContext(AppContext);

  //fetch categories and uoms when the component mounts
  useEffect(() => {
    fetchProductCategories();

  }, []);
  
  
  // Reset the form when `category` state changes (initial or after submit)
  useEffect(() => {reset(category); }, [category, reset]);
  
  
  const fetchProductCategories = async () => {
    const apiEndpoint = 'product_categories';
    const apiMethod = 'GET';
    const parameters = {};
    setIsLoading(true);
    const params = {};
    try {
      const response = await handleApi(apiEndpoint, params, userData, apiMethod, parameters);
      if (response.error) {
        console.error('Error fetching category categories', response.errorMessage);
        return; // Exit function to avoid further processing
      }
      const { status, statusText } = response;
      if (status === 200) {
        const fetchedCategories = response.data; // fetched categories
        //format Category categories  for select options
        const transformedCategories = fetchedCategories.map(category => ({
          value: category.id,
          label: category.name
        }));
    
        // Now update the state with the transformed data
        setCategories(transformedCategories);
      } else {
        console.error(`Error ${status}: ${statusText}`); // Handle non-200 responses
      }
    } catch (error) {
      console.error(error.message || 'An unexpected error occurred.'); // Handle unexpected errors
    } finally {setIsLoading(false);}
  };

  
  


  // Handle the cancel action
  const handleCancel = () => {
    // Create an object with default values for each field from CategoryConfig
    const resetValues = CategoryConfig.reduce((acc, field) => {
      acc[field.name] = field.defaultValue === undefined ? '' : field.defaultValue; // Handle undefined defaultValue
      // Special handling for date fields if defaultValue is not suitable for empty
      if (field.type === 'date') {
        acc[field.name] = ''; // Or null, depending on how you want to represent empty date
      }
      return acc;
    }, {});
    // For fields like salutation, first_name, last_name not in CategoryConfig, explicitly set them
    resetValues.name = '';

    resetValues.parent_category = '';
    // Reset the form state with default values
    reset(resetValues); // This will clear the react-hook-form state
    // Optionally reset category state as well, to ensure consistency and trigger useEffect if needed
    

    // Reset the image and other states if needed
    setDisplayImg('');
    setImgType('');
    setCategory({ });
  };

  const navigate = useNavigate(); 

  // handle closing the page
  const handleClosePage = () => {
   navigate(-1);   // Navigate back to the previous page
  };

  const convertFile = (files) => {
    if (files && files.length > 0 && files[0] instanceof File) {
      const fileRef = files[0];
      const fileType = fileRef.type;
      const reader = new FileReader();
      reader.readAsBinaryString(fileRef);
      reader.onload = (ev) => {
        const base64Data = btoa(ev.target.result); // Get base64 string
        // Update the states that hold the image data
        setDisplayImg(base64Data);
        setImgType(fileType);
        setCategory(prevCategory => ({
          ...prevCategory,
          photo: { data: base64Data, contentType: fileType } // Direct photo property
        }));
      };
    }
  };

  const handleImgChange = (event) => {
    const { name, files } = event.target;
    if (name === "logo") {convertFile(files);}
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
  };

  
  
  
  const handleCategoryFormSubmit = async (dataFromForm) => {
    console.log('dataFromForm sir ',dataFromForm)
    // Check if category already exists using the reusable findRecordSafe
    const existingCategory = findRecordSafe(dataFromForm, categories, ['name']);

    
    if (existingCategory) {
      toast.error(
        `Category "${dataFromForm.name || 'Unknown'}" already exists${
          existingCategory.barcode ? ` with barcode "${existingCategory.barcode}"` : ''
        }.`
      );
      return; // Stop submission
    }
  
    // Safe debugging: stringify form data
    try {
      console.log(
        'Form data received from react-hook-form (safe stringify):',
        JSON.stringify(dataFromForm, null, 2)
      );
    } catch (e) {
      console.error('Failed to stringify `dataFromForm`. Circular reference found:', dataFromForm);
      toast.error('Form data is corrupted. Check the console for details.');
      setIsLoading(false);
      return;
    }
    // Create a new payload object with only the necessary fields
    const payload = {
        name: dataFromForm.name,
        // CRITICAL FIX 3: Map the submitted form field 'category_id' 
        // to the API's expected 'parent_category' field.
        parent_category: dataFromForm.category_id,
    };
  
    // Add image data if available
    payload.photo = displayImg && imgType ? { data: displayImg, contentType: imgType } : null;
  
    // Safe debugging: stringify final payload
    try {
      console.log('Final payload to send to API (safe stringify):', JSON.stringify(payload, null, 2));
    } catch (e) {
      console.error('Final payload has a circular reference. Inspect the object below.', payload);
      toast.error('The final payload is corrupted. Check the console for details.');
      setIsLoading(false);
      return;
    }
  
    const apiMethod = payload.id ? 'PUT' : 'POST';
    const parameters = payload.id ? { id: payload.id } : {};
  
    setIsLoading(true);
  
    try {
      const response = await handleApi('product_categories', payload, userData, apiMethod, parameters);
  
      if (response.status === 200 || response.status === 201) {
        toast.success('Category saved successfully!');
        handleCancel(); // Reset form
      } else {
        toast.error(`Error saving category: ${response.statusText || 'An unknown error occurred'}`);
      }
    } catch (error) {
      toast.error('Error saving category: ' + error.message);
    } finally {
      setActionCount(actionCount + 1);
      setIsLoading(false);
    }
  };
  
// The SVG path below represents a 2D, open-top box outline.
const svgString = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="${currentColor}" width="100" height="100">
  <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6m6 0a2.25 2.25 0 012.25-2.25h2.25A2.25 2.25 0 0121 6m-18 0v1.5c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125V6M3 6h18m-18 8.25V18a2.25 2.25 0 002.25 2.25h13.5A2.25 2.25 0 0021 18v-3.75m-18 0V12h18v2.25" />
</svg>`;
const base64Svg = btoa(unescape(encodeURIComponent(svgString)));
const defaultPhotoUrl = `data:image/svg+xml;base64,${base64Svg}`;

  // Conditionally set the photo URL to either the uploaded image or the default SVG
  const photoUrl = displayImg && imgType ? `data:${imgType};base64,${displayImg}` : defaultPhotoUrl;


  return (
    <Layout>
      <div className="m-1 sm:m-2">
        {/* New flex container for the title and close button */}
        <div className="relative flex justify-between items-center">
          <h1 className="text-center font-bold flex-grow">NEW PRODUCT CATEGORY</h1>
          <button
            onClick={handleClosePage}
            className="p-1 rounded-lg text-red-400 bg-white hover:bg-gray-50 hover:text-gray-600"
          >
            <MdOutlineCancel color={currentColor} size={30} />
          </button>
        </div>
        {/* Tab Buttons */}
        
        <ToastContainer position="top-center" autoClose={2000} />

        {isLoading ? (
          <div className="flex items-center flex-col py-6">
            <Audio height="80" width="80" radius="9" color={currentColor} ariaLabel="loading" />
            <p className="mt-2 text-white">Loading. Please wait...</p>
          </div>
        ) : (
          <div className="bg-whitey p-2 sm:p-4 my-4 my-auto mx-auto rounded-xl shadow-2xl w-fit">
            <div className="mx-auto border-b border-gray-400 bg-gray-500 transition-all duration-200 cursor-pointer rounded-xl shadow-2xl p-8">
              <CategoryProfile
                  fields={CategoryConfig}
                  control={control}
                  register={register}
                  photo={photoUrl} // Pass the state variable that holds the image data
                  onChange={handleChange}
                  categories={categories} // Pass categories to CategoryProfile
                  uoms={uoms} // Pass unit of measures  to CategoryProfile
                  handleImgChange={handleImgChange}
                  onSubmit={handleSubmit(handleCategoryFormSubmit)}
                  categoryData={category} // Ensure categoryData is passed correctly for initial values
                  onCancel={handleCancel} // Pass the proper clearing function here
                  errors={errors} // <-- Pass `errors` down
                  reset={reset} // <-- NEW: Pass the `reset` function from `useForm`
                  isLoading={isLoading}
                />
              </div>
            
          </div>
        )}
      </div>
    </Layout>
  );
};
export default NewCategory;